import API from "Signups/SignupView/API";
import API2 from "Signups/API";
import { personType } from "./personType";

export default async function removeFromSignup({
  signupID,
  removalType,
  postData,
  isItemType,
}) {
  if (isItemType && removalType === "slot") {
    return await API2.updateUserSignupSlots(postData).post();
  } else {
    // console.log({ signupID, userType, postData });
    if (removalType === personType.ADDITIONAL_NAME) {
      return await API.removeAdditionalName(signupID, postData).post();
    }
    if (removalType === personType.HOUSEHOLD_MEMBER) {
      return await API.removeHouseholdMember(signupID, postData).post();
    }
    if (removalType === personType.USER) {
      return await API.removeUser(signupID, postData).post();
    }
    if (removalType === personType.HOUSEHOLD) {
      return await API.cancelAllHouseholdUserSignups(signupID, postData).post();
    }
  }
}
